import { Box, FormGroup, FormControlLabel, Tooltip } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../../../../theme';
import { SwitchStyled } from '../../../../../../theme/style';
import { KPI_STATE } from '../../../constants';
import { EventUpdateStatus } from '../../../dashboardModalInterface';
import { CardAnswerModalities } from '../../styled';

interface CardSelectedProps {
    codemodalite?: number,
    label?: string,
    hide?: boolean,
    excluded?: boolean,
    eventUpdate?(id: number, event: EventUpdateStatus): void;
    isChildren?: boolean,
    isClone?: boolean,
}

const CardSelectAnswer: FC<CardSelectedProps> = ({ codemodalite, label, eventUpdate, hide = false, excluded = false, isChildren = false, isClone = false }) => {
    const [hiddenAnswer, setHiddenAnswer] = useState<boolean>(hide);
    const [hiddenAnswerDisabled, setHiddenAnswerDisabled] = useState<boolean>(false);
    const [excludeAnswer, setExcludeAnswer] = useState<boolean>(excluded);
    const { t } = useTranslation('dashboard');

    const handleStatusChange = () => {
        if (eventUpdate && codemodalite) {
            if (!hiddenAnswer && !excludeAnswer) {
                eventUpdate(codemodalite, { type: KPI_STATE.DISPLAYED });
            }
            if (excludeAnswer || (hiddenAnswer && excludeAnswer)) {
                eventUpdate(codemodalite, { type: KPI_STATE.EXCLUDED });
            }
            if (hiddenAnswer && !excludeAnswer) {
                eventUpdate(codemodalite, { type: KPI_STATE.HIDDEN });
            }
        }
    };
    useEffect(handleStatusChange, [hiddenAnswer, excludeAnswer]);

    return (
        <CardAnswerModalities style={isChildren ? { backgroundColor: colors.grey450 } : undefined}>
            <Box sx={{ display: 'flex', alignItems: 'left' }}>
                <TypographyStyledGlobal
                    color={(hiddenAnswer || excludeAnswer) ? colors.grey400 : colors.grey200}
                    margin='0 0 0 15px'
                    size={fontSize.sm}
                    sx={excludeAnswer ? { textDecoration: 'line-through' } : {}}
                    weight={fontWeight.regular}
                >
                    {label}
                </TypographyStyledGlobal>
            </Box>
            {!isChildren && !isClone && (
                <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                    <Tooltip
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    bgcolor: colors.grey100,
                                    borderRadius: '4px',
                                    color: colors.grey000,
                                    fontSize: fontSize.sm,
                                    fontWeight: fontWeight.semiRegular,
                                    maxWidth: 360,
                                    padding: '6px 10px',
                                    '& .MuiTooltip-arrow': { color: colors.grey100 },
                                },
                            },
                        }}
                        placement="top"
                        title={t('addIndicatorModal.refineIndicatorAnswer.hideTooltip')}
                        arrow
                    >
                        <FormControlLabel
                            control={<SwitchStyled checked={hiddenAnswer} disabled={hiddenAnswerDisabled} />}
                            label={(
                                <TypographyStyledGlobal
                                    color={(hiddenAnswer) ? colors.grey100 : colors.grey300}
                                    size={fontSize.sm}
                                    weight={fontWeight.regular}
                                >
                                    {t('addIndicatorModal.refineIndicatorAnswer.hide')}
                                </TypographyStyledGlobal>
                            )}
                            onChange={() => {
                                setHiddenAnswer(!hiddenAnswer);
                            }}
                            value={hiddenAnswer}
                        />
                    </Tooltip>
                    <Tooltip
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    bgcolor: colors.grey100,
                                    borderRadius: '4px',
                                    color: colors.grey000,
                                    fontSize: fontSize.sm,
                                    fontWeight: fontWeight.semiRegular,
                                    maxWidth: 360,
                                    padding: '6px 10px',
                                    '& .MuiTooltip-arrow': { color: colors.grey100 },
                                },
                            },
                        }}
                        placement="top"
                        title={t('addIndicatorModal.refineIndicatorAnswer.excludeTooltip')}
                        arrow
                    >
                        <FormControlLabel
                            control={(
                                <SwitchStyled checked={excludeAnswer} />
                            )}
                            label={(
                                <TypographyStyledGlobal
                                    color={(excludeAnswer) ? colors.grey100 : colors.grey300}
                                    size={fontSize.sm}
                                    weight={fontWeight.regular}
                                >
                                    {t('addIndicatorModal.refineIndicatorAnswer.exclude')}
                                </TypographyStyledGlobal>
                            )}
                            onChange={() => {
                                setExcludeAnswer(!excludeAnswer);
                                setHiddenAnswer(!excludeAnswer);
                                setHiddenAnswerDisabled(!hiddenAnswerDisabled);
                            }}
                        />
                    </Tooltip>
                </FormGroup>
            )}
        </CardAnswerModalities>
    );
};

export default CardSelectAnswer;
